import React from 'react'
import styled from '@emotion/styled'
import { isRaceDetails } from '@mobi/betslip/helpers/typeGuards'
import type { EventDetails } from '@mobi/betslip/types'
import { Button } from '@mobi/component-library/Base/Buttons/Button'
import { spacing } from '@mobi/component-library/Foundations'
import { RaceNotificationButton } from '@core/Areas/Racing/Components/RaceNotificationButton'

export const SetAlertNotificationButton: React.FC<{ selectionDetails: EventDetails | null }> = ({
  selectionDetails,
}) => {
  if (!isRaceDetails(selectionDetails)) return null
  if (selectionDetails.races.length > 1) return null

  return (
    <RaceNotificationButton
      raceStatus='Open'
      raceTime={new Date(selectionDetails.races[0].raceTime)}
      meetingId={selectionDetails.races[0].meetingId}
      raceNumber={selectionDetails.races[0].raceNumber}
      meetingName={selectionDetails.races[0].meetingName}
      meetingDate={selectionDetails.races[0].meetingDate}
      buttonComponent={ButtonComponent}
    />
  )
}

// ===============
// Local Component
// ===============

const ButtonComponent: React.FC<React.HTMLAttributes<HTMLButtonElement>> = ({
  onClick,
  children,
  ...attributes
}) => (
  <ButtonStyled color='tertiary_grey' size='xs' onClick={onClick} {...attributes}>
    {children} Alert
  </ButtonStyled>
)

// ======
// Styles
// ======

const ButtonStyled = styled(Button)({
  padding: `${spacing.smx1} ${spacing.smx2}`,
  gap: spacing.smx2,
})
